<template>
  <div>
    <detail-view-file-property-table
      :attachments="attachments()"
    >
    </detail-view-file-property-table>

    <div class="cta" v-if="hasMore">
      <a :href="detailViewAttachmentsLink" type="button" class="btn grey-to-blue inline">View All</a>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import DetailViewFilePropertyTable from "./detail-view-file-property-table.vue";
  import FileProperty from "../../detailViewBuilder/models/fileProperty";
  import { RouteHelper } from "~/helpers/routeHelper";
  import { Route } from "~/enums/route";
  import selectedMixin from "../mixins/selectedMixin";
  import ContentElementComponent from "./content-element-component.vue";

  export default Vue.extend({
    extends: ContentElementComponent,
    name: "detail-view-content-element-file-property",
    mixins: [selectedMixin],
    components: {
      DetailViewFilePropertyTable
    },
    props: {
      showingAllAttachments: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      detailViewId() {
        return this.contentElement.rootModel.detail_view_id;
      },
      entryId() {
        return this.selectedObjectModelEntry.id;
      },
      propertyLabelTitle() {
        return this.contentElement.property.label_title;
      },
      propertyId() {
        return this.contentElement.property.id;
      },
      hasMore() {
        if (this.showingAllAttachments) return false;
        const uploads = this.entry.file_uploads;
        if (!uploads) return false;
        const uploadsForProperty = uploads.filter(upload => upload.property_client_id === this.contentElement.property.client_id);
        return uploadsForProperty.length > this.contentElement.file_display_limit;
      },
      detailViewAttachmentsLink() {
        const routeEnum = Route.detailViewFileAttachments;
        const query = {};
        query["from"] = "Reporting & Submissions Dashboard";
        query["from_show_attachments"] = "true";

        const wildcards = [
          {'wildcard': ':detail_view_id', modelOrId: this.detailViewId },
          {'wildcard': ':entry_id', modelOrId: this.entryId },
          {'wildcard': ':property_id', modelOrId: this.propertyId }
        ];

        return RouteHelper.path({ route: routeEnum, namedWildcardOptions: wildcards, query });
      }
    },
    methods: {
      attachments() {
        if (!this.entry.file_uploads) return [];

        const attachments = this.entry.file_uploads.filter(upload => {
          return upload.property_client_id === this.contentElement.property.clientIdOrId;
        })

        if (this.showingAllAttachments) return attachments;

        const displayLimit = this.contentElement.file_display_limit;
        return attachments.slice(0, displayLimit);
      }
    }
  })
</script>